import { avoidBreakInside } from '@provider/print';
import { generateJsxKey } from '@utils/ast';
import { wrapper, table } from './printer.table.style.js';
import { jsx } from 'react/jsx-runtime';

function printTable(data, context) {
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    ...avoidBreakInside(),
    children: /*#__PURE__*/jsx("table", {
      ...data.props,
      className: table,
      children: data.children
    })
  }, generateJsxKey(context));
}
function printCell(Tag, data, context) {
  return /*#__PURE__*/jsx(Tag, {
    ...data.props,
    ...avoidBreakInside(),
    children: data.children
  }, generateJsxKey(context));
}

export { printCell, printTable };
//# sourceMappingURL=printer.table.js.map
